<template>
    <v-dialog
        v-model="dialog"
        :fullscreen="fullscreen"
        :max-width="maxWidth"
        :transition="transition"
        :overlay="!fullscreen"
        scrollable
    >
        <v-btn
            slot="activator"
            icon
            fab
            dark
            small
            color="grey darker-1"
        ><v-icon>remove_red_eye</v-icon></v-btn>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Visualizar Despesa</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items v-if="isEditable">
                    <v-btn dark flat @click.native="save" :disabled="$v.$invalid || saving" :loading="saving">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-list three-line>
                    <v-container grid-list-lg>
                        <v-layout wrap>
                            <v-flex xs6>
                                <v-autocomplete
                                    label="Status"
                                    append-icon="status"
                                    :items="['Aguardando validação', 'Aprovada', 'Questionada', 'Rejeitada']"
                                    v-model="objDespesa.status"
                                    :value="objDespesa.status"
                                    :disabled="!isEditable"
                                    required
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    label="Categoria"
                                    append-icon="category"
                                    :value="objDespesa.categoria.nome"
                                    disabled
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    label="Data da Despesa"
                                    append-icon="event"
                                    :value="computedDateFormatted"
                                    disabled
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    label="Valor"
                                    append-icon="attach_money"
                                    :value="objDespesa.valor | currency | placeholder('R$ 0,00')"
                                    disabled
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    name="obs"
                                    label="Observação"
                                    v-model="objDespesa.obs"
                                    :value="objDespesa.obs"
                                    :disabled="!isEditable"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-divider></v-divider>
                    <v-img
                        :src="(`${objDespesa.img_nf.nome}.${objDespesa.img_nf.ext}`)"
                        alt="Nota Fiscal"
                        v-if="isOnline && objDespesa.img_nf.nome"
                    />
                    <v-img
                        :src="objDespesa.img_nf.base64"
                        alt="Nota Fiscal"
                        v-if="objDespesa.img_nf.base64"
                    />
                </v-list>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapState             } from 'vuex';
    import { validationMixin      } from 'vuelidate';
    import { required, requiredIf } from 'vuelidate/lib/validators';
    import Util                     from '@/util';
    import modalMixin               from '@/mixins/modalMixin';
    import momentMixin              from '@/mixins/momentMixin';

    const objDespesaDefault = {
        categoria  : {
            nome : null
        },
        dt_despesa : null,
        valor      : null,
        obs        : null,
        img_nf     : {
            nome   : null,
            ext    : null,
            base64 : null
        }
    }

    export default {
        name       : 'DespesaDetailModal',
        mixins     : [modalMixin, momentMixin, validationMixin],
        components : {},
        validations() {
            if (this.isObsRequired) {
                return {
                    objDespesa : {
                        status : {
                            required
                        },
                        obs    : {
                            required
                        }
                    }
                }
            } else {
                return {
                    objDespesa : {
                        status : {
                            required
                        }
                    }
                }
            }
        },
        props      : {
            isEditable  : {
                type    : Boolean,
                default : false
            },
            despesa     : {
                type    : Object,
                default : function () {
                    return objDespesaDefault
                },
            },
            reloadGrid  : Function
        },
        methods    : {
            setObjDespesa() {
                if (this.despesa._id) {
                    this.objDespesa  = JSON.parse(JSON.stringify(this.despesa));
                    this.positivo    = this.objDespesa.categoria.positivo || undefined;
                } else {
                    this.resetObjDespesa();
                }
            },
            resetObjDespesa() {
                this.objDespesa            = JSON.parse(JSON.stringify(objDespesaDefault));
                this.objDespesa.dt_despesa = this.formatDateUTC(new Date(), 'YYYY-MM-DD');
            },
            save() {
                this.saving = true;
                const id         = (this.objDespesa._id ? `/${this.objDespesa._id}` : '');
                const objDespesa = {
                    _id    : this.objDespesa._id,
                    status : this.objDespesa.status,
                    obs    : this.objDespesa.obs
                }
                this.$axios.patch(`despesas${id}`, objDespesa).then(response => {
                    this.toggleDialog();
                    window.getApp.snackbar = {
                        show  : true,
                        color : 'green',
                        text  : this.mode.snack
                    };
                    setTimeout(this.reloadGrid(), 3000);
                    // this.resetObjDespesa();
                }).catch(error => {
                    // this.toggleDialog();
                    const errorMsg = Util.getErrorMsg(error.response.data);
                    console.error(errorMsg.detailedMsg);
                    setTimeout(this.reloadGrid(), 3000);
                    window.getApp.snackbar = {
                        show  : true,
                        color : 'red',
                        text  : errorMsg.msg
                    };
                }).finally(() => {
                    this.saving = false;
                });
            }
        },
        computed   : {
            ...mapState(['user']),
            isAdmin() {
                return this.user.perfis.some(perfil => perfil === 'Administrador');
            },
            id() {
                return this.objDespesa._id;
            },
            statusColor () {
                const color = {
                    "Aprovada"             : "success",
                    "Questionada"          : "warning",
                    "Rejeitada"            : "error",
                    "Aguardando validação" : "grey darker-1"
                }
                return color[this.objDespesa.status];
            },
            isObsRequired () {
                return (this.objDespesa.status == 'Questionada' || this.objDespesa.status == 'Rejeitada');
            },
            computedDateFormatted () {
                return this.formatDateUTC(this.objDespesa.dt_despesa);
            }
        },
        mounted() {
            this.setObjDespesa();
        },
        watch      : {
            dialog(novo, antigo) {
                if (novo) {
                    this.setObjDespesa();
                }
            }
        },
        data() {
            return {
                dtDespesaDP : false,
                objDespesa  : JSON.parse(JSON.stringify(objDespesaDefault)),
                categorias  : []
            };
        }
    };
</script>

<style lang="stylus" scoped>
    .despesa-fab
        bottom        : 10% !important;
        right         : 3;
        border-radius : 5;
</style>
